import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const listCoUser = createAsyncThunk('co-users/list', async (_, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/list`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const listUser = createSlice(
  {
    name: 'addGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [listCoUser.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [listCoUser.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [listCoUser.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default listUser;
